import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';
import { LogoFeatureComponent } from '../logo/feature/logo-feature.component';

const log = new LoggingService();
export const LogoRoute: Ng2StateDeclaration = {
    name: 'weblogo',
    url: '/weblogo',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: LogoFeatureComponent
};
